module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Dinner-b20aa11aae6535663ccff3ad8afe6017.svg";